:host {
	display: block;
}

.w2d-shared-jackpot-section {
	&__wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--ace-primitive-spacing-x-loose);
	}

	&__teaser {
		display: flex;
		flex-direction: column;
		gap: var(--ace-primitive-spacing-x-loose);

		@include mq($desktop) {
			align-items: center;
			flex-direction: row;
			justify-content: space-between;
		}
	}

	&__headline {
		display: flex;
		flex-direction: column;
		gap: var(--ace-primitive-spacing-x-tight);
	}
}
